// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2U2cG","content":"styles_content__16h88","selectAll":"styles_selectAll__2tQAZ"};